import { render, staticRenderFns } from "./LevItemList.vue?vue&type=template&id=deddf4ca"
import script from "./LevItemList.vue?vue&type=script&lang=js"
export * from "./LevItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports